import { render, staticRenderFns } from "./strickerlist.vue?vue&type=template&id=5cb3961e&scoped=true&"
import script from "./strickerlist.vue?vue&type=script&lang=js&"
export * from "./strickerlist.vue?vue&type=script&lang=js&"
import style0 from "./strickerlist.vue?vue&type=style&index=0&id=5cb3961e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb3961e",
  null
  
)

export default component.exports